/* SaveMom Shopify Theme — theme.js */
(function () {
  'use strict';

  /* ── Product Gallery Thumbnails ─────────── */
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  const mainImage = document.getElementById('main-product-image');

  if (mainImage && thumbBtns.length > 0) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const src = btn.dataset.src;
        const alt = btn.dataset.alt;
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        thumbBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* ── Quantity Selector ──────────────────── */
  const qtyInputs = document.querySelectorAll('.qty-input');

  qtyInputs.forEach(function (input) {
    const wrap = input.closest('.quantity-selector');
    if (!wrap) return;

    const minus = wrap.querySelector('.qty-btn--minus');
    const plus  = wrap.querySelector('.qty-btn--plus');

    if (minus) {
      minus.addEventListener('click', function () {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        const val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }

    input.addEventListener('change', function () {
      const val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) input.value = 1;
    });
  });

  /* ── Cart Page Qty Buttons ──────────────── */
  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.key;
      var input = document.querySelector('.cart-qty-input[name="updates[]"][id="updates_' + key + '"]')
                  || btn.closest('.cart-item__qty').querySelector('.cart-qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (btn.classList.contains('cart-qty-btn--minus')) {
        val = Math.max(0, val - 1);
      } else {
        val = val + 1;
      }
      input.value = val;
      clearTimeout(input._cartTimer);
      input._cartTimer = setTimeout(function () {
        var form = document.getElementById('cart-form');
        if (form) form.submit();
      }, 600);
    });
  });

  /* ── Smooth Scroll for anchor links ─────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Product Card Scroll-Reveal ─────────── */
  // Immediately reveal cards already in viewport on load,
  // then animate the rest as they scroll into view.
  const cards = document.querySelectorAll('.product-card');

  if (cards.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('card--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  } else {
    // Fallback: show all cards immediately
    cards.forEach(function (card) {
      card.classList.add('card--visible');
    });
  }

  /* ── Floating Dot Decorations on Product Grid ── */
  // Injects a handful of animated floating dots into .product-grid-section
  var gridSections = document.querySelectorAll('.product-grid-section');
  gridSections.forEach(function (section) {
    var dots = [
      { size: 8,  top: '12%', left: '5%',   delay: '0s',   dur: '4.2s' },
      { size: 6,  top: '80%', left: '8%',   delay: '1.1s', dur: '5s'   },
      { size: 10, top: '25%', right: '6%',  delay: '0.5s', dur: '3.8s' },
      { size: 7,  top: '65%', right: '10%', delay: '2s',   dur: '4.6s' },
      { size: 5,  top: '45%', left: '50%',  delay: '0.8s', dur: '5.5s' },
      { size: 9,  top: '8%',  left: '40%',  delay: '1.6s', dur: '4s'   },
    ];
    dots.forEach(function (d) {
      var el = document.createElement('span');
      el.style.cssText = [
        'position:absolute',
        'border-radius:50%',
        'pointer-events:none',
        'z-index:0',
        'width:'  + d.size + 'px',
        'height:' + d.size + 'px',
        'top:'    + d.top,
        d.left  ? 'left:'  + d.left  : 'right:' + d.right,
        'background: radial-gradient(circle, rgba(0,163,163,.45), rgba(255,143,171,.3))',
        'animation: dotPop ' + d.dur + ' ' + d.delay + ' ease-in-out infinite',
        'will-change: transform, opacity',
      ].join(';');
      section.appendChild(el);
    });
  });

})();
